import type {ReactAction} from '@netx/core/bootstrap';
import {faEnvelope} from '@netx/core-icons';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {canContact} from '../enablers';
import {AppContactLabel} from '../locales';

export const appActionContactRouteIcon = faEnvelope;

/**
 * Route to contact
 * @param params
 * @returns Action
 */
export const appActionContactRoute = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'app-contact-route',
	cb: () => dispatcher.trigger('app:contact'),
	enableTest: () => canContact(),
	icon: appActionContactRouteIcon,
	get label() {
		return AppContactLabel.ROUTE;
	},
	...params,
});
